import { useDispatch } from 'react-redux';
import { removeUploadingFile } from '../state/actions';

export const useRemoveUploadFile = () => {
  const dispatch = useDispatch();

  return async fileId => {
    // Display the file state for 1s
    await new Promise(r => setTimeout(r, 1000));

    dispatch(removeUploadingFile({ fileId }));
  };
};
